export default class LandingBrandsEntity {
    constructor (data) {
        return data;
    }

}
